export const SET_BRAND = 'SET_BRAND'
export const LOGOUT = 'LOGOUT';
